import getUniqueId from 'helpers/getUniqueId'

import { PageEditorRowType } from 'js/page/PageEditor/PageEditor.types'

// Rows and widgets need guids for drag-and-drop. Use server widget guids and row
// index so revision navigation reuses the same components instead of remounting.
export function addUniqueGuids(
    rows: Omit<PageEditorRowType, 'rowGuid'>[],
): PageEditorRowType[] {
    return rows.map((row, rowIndex) => ({
        ...row,
        rowGuid: `row-${rowIndex}`,
        columns: row.columns.map((column) => ({
            ...column,
            widgets: column.widgets.map((widget) => ({
                ...widget,
                widgetGuid: widget.guid || getUniqueId('widget'),
            })),
        })),
    }))
}
